'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileMetadataRecord = function (_Record) {
  _inherits(FileMetadataRecord, _Record);

  function FileMetadataRecord() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FileMetadataRecord);

    return _possibleConstructorReturn(this, (FileMetadataRecord.__proto__ || Object.getPrototypeOf(FileMetadataRecord)).call(this, _extends({}, properties, {
      fileSize: properties.size || 0
    })));
  }

  return FileMetadataRecord;
}((0, _immutable.Record)({
  expiresAt: 0,
  url: '',
  name: '',
  extension: '',
  type: '',
  fileSize: 0
}));

exports.default = FileMetadataRecord;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/file-metadata/records/FileMetadataRecord.js
// module id = 817
// module chunks = 2 3